/**
 * Redesign v2: pannello informazioni fisso della scheda prodotto (solo desktop).
 * Se il pannello è più alto dello schermo, scorre con la pagina finché il suo fondo
 * raggiunge il bordo inferiore e da lì resta fermo; se ci sta, resta sotto l'header.
 * Imposta --gdm-d-panel-top sull'elemento .product-details.
 */
const DESKTOP = window.matchMedia('(min-width: 990px)');
const MARGIN = 16;
const observed = new WeakSet();

function update(panel) {
  if (!DESKTOP.matches) {
    panel.style.removeProperty('--gdm-d-panel-top');
    return;
  }
  const headerOffset = parseFloat(getComputedStyle(panel).getPropertyValue('--sticky-header-offset')) || 0;
  const fitsTop = headerOffset + MARGIN;
  const bottomAligned = window.innerHeight - panel.offsetHeight - MARGIN;
  panel.style.setProperty('--gdm-d-panel-top', `${Math.round(Math.min(fitsTop, bottomAligned))}px`);
}

function setup() {
  document.querySelectorAll('.product-details.sticky-content--desktop').forEach((panel) => {
    if (observed.has(panel)) return;
    observed.add(panel);
    const run = () => update(panel);
    new ResizeObserver(run).observe(panel);
    panel.addEventListener('click', () => requestAnimationFrame(() => requestAnimationFrame(run)));
    run();
  });
}

DESKTOP.addEventListener('change', () => {
  document.querySelectorAll('.product-details.sticky-content--desktop').forEach(update);
});
window.addEventListener('resize', () => {
  document.querySelectorAll('.product-details.sticky-content--desktop').forEach(update);
});

setup();
document.addEventListener('DOMContentLoaded', setup);
document.addEventListener('shopify:section:load', setup);
